import { $api } from "../generated/client";

/**
 * Current and former Baback super admins, to name their actions on a shop
 * "First Last (Support Baback)" (BAB-3035). Rarely changes: cached long.
 */
export function useBabackSupport(shopId: string) {
  return $api.useQuery(
    "get",
    "/shops/{shopId}/baback-support",
    { params: { path: { shopId } } },
    { staleTime: 10 * 60 * 1000 },
  );
}
